import { render, staticRenderFns } from "./CustomerOptions.vue?vue&type=template&id=f18ddfe8&scoped=true"
import script from "./CustomerOptions.vue?vue&type=script&lang=js"
export * from "./CustomerOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18ddfe8",
  null
  
)

export default component.exports